/* A version's note under its date in the timeline (mockup v3 P4). */
.note {
  margin: 2px 0 0;
  color: var(--text-muted);
  font-size: var(--font-size-12);
}

.editor {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-1);
  margin-top: 2px;
}

.error {
  flex-basis: 100%;
  margin: 0;
  color: var(--danger-text);
  font-size: var(--font-size-12);
}
